module.exports = __webpack_public_path__ + "static/media/heartEmpty.6b422ad9.svg";